import { render, staticRenderFns } from "./AppNavigator.vue?vue&type=template&id=618eab20&"
import script from "./AppNavigator.vue?vue&type=script&lang=ts&"
export * from "./AppNavigator.vue?vue&type=script&lang=ts&"
import style0 from "./AppNavigator.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports